import React, { useEffect, useState } from 'react';
import TR from './../../Trans';
import Divider from '@mui/material/Divider';
import TrackListScroller from './../items/TrackListScroller';
import ContentContainer from './../items/ContentContainer';
import SearchFilters from './../items/SearchFilters';
import List from '@mui/material/List';
import Waiting from './../items/Waiting';
import TrackListContainer from './../items/TrackListContainer';
import IconButton from '@mui/material/IconButton';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Grid from '@mui/material/Grid';
import sessionStore from './../../stores/session';
import songbookSessionStore from './../../stores/songbookSession';
import environmentStore from './../../stores/environment';
import { decades } from '../../common/decades';
import catalogStore from './../../stores/catalog';
import navigationStore from '../../stores/navigation';

function Catalog(props) {
  const itemsOnPage = 25;
  const toggleSearchFilters = navigationStore((state) => state.toggleSearchFilters);
  const isWaiting = catalogStore((state) => state.isWaiting);
  const sessionToken = props.isSongbook ? songbookSessionStore((state) => state.sessionToken) : sessionStore((state) => state.sessionToken);
  const isEnvironmentSet = environmentStore((state) => state.isEnvironmentSet);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const environment = environmentStore((state) => state.environment);
  const filterLanguages = catalogStore((state) => state.filterLanguages);
  const setLanguageFilter = catalogStore((state) => state.setLanguageFilter);
  const filterGenres = catalogStore((state) => state.filterGenres);
  const setGenreFilter = catalogStore((state) => state.setGenreFilter);
  const filterDecades = catalogStore((state) => state.filterDecades);
  const filterAlphabets = catalogStore((state) => state.filterAlphabets);
  const setDecadeFilter = catalogStore((state) => state.setDecadeFilter);
  const setAlphabetFilter = catalogStore((state) => state.setAlphabetFilter);
  const setAllLanguageFilters = catalogStore((state) => state.setAllLanguageFilters);
  const setAllDecadeFilters = catalogStore((state) => state.setAllDecadeFilters);
  const setAllGenreFilters = catalogStore((state) => state.setAllGenreFilters);
  const setAllAlphabetFilters = catalogStore((state) => state.setAllAlphabetFilters);
  const isAllLanguageFiltersSet = catalogStore((state) => state.isAllLanguageFiltersSet);
  const isAllGenreFiltersSet = catalogStore((state) => state.isAllGenreFiltersSet);
  const isAllDecadeFiltersSet = catalogStore((state) => state.isAllDecadeFiltersSet);
  const isAllAlphabetFiltersSet = catalogStore((state) => state.isAllAlphabetFiltersSet);
  const getTracks = catalogStore((state) => state.getTracks);
  const getTracksMore = catalogStore((state) => state.getTracksMore);
  const tracks = catalogStore((state) => state.tracks);
  const totalCount = catalogStore((state) => state.totalCount);
  const isOrderBySongTitleSet = catalogStore((state) => state.isOrderBySongTitleSet);
  const isOrderByArtistNameSet = catalogStore((state) => state.isOrderByArtistNameSet);
  const isOrderByPopularitySet = catalogStore((state) => state.isOrderByPopularitySet);
  const setOrderBySongTitle = catalogStore((state) => state.setOrderBySongTitle);
  const setOrderByArtistName = catalogStore((state) => state.setOrderByArtistName);
  const setOrderByPopularity = catalogStore((state) => state.setOrderByPopularity);
  const isFinished = catalogStore((state) => state.isFinished);
  const isSearchFiltersOn = navigationStore((state) => state.isSearchFiltersOn);

  const alphabets = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "Å", "Ä", "Ö", "#"];

  useEffect(() => {
    if (!environment) {
      getEnvironment(sessionToken);
    }
  }, []);

  const handleScrollDown = () => {
    console.log("more tracks");
    if (tracks) {
      getTracksMore(sessionToken, itemsOnPage);
    }
  };

  const scrollToTop = () => {
    const element = document.getElementById('catalog-tracklist');
    if (element) {
      element.scrollTop = 0;
    }
  };

  const handleLanguageChange = (id, isSelected) => {
    setLanguageFilter(id, !isSelected);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const handleGenreChange = (id, isSelected) => {
    setGenreFilter(id, !isSelected);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const handleDecadeChange = (id, isSelected) => {
    setDecadeFilter(id, !isSelected);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const handleAlphabetChange = (id, isSelected) => {
    setAlphabetFilter(id, !isSelected);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const handleAllLanguagesChange = () => {
    if (environment) {
      setAllLanguageFilters(environment.track_languages);
      getTracks(sessionToken, itemsOnPage);
      scrollToTop();
    }
  };

  const handleAllGenresChange = () => {
    if (environment) {
      setAllGenreFilters(environment.genres);
      getTracks(sessionToken, itemsOnPage);
      scrollToTop();
    }
  };

  const handleAllDecadesChange = () => {
    setAllDecadeFilters(decades);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const handleAllAlphabetsChange = () => {
    setAllAlphabetFilters(alphabets);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const orderByArtistName = () => {
    setOrderByArtistName();
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const orderBySongTitle = () => {
    setOrderBySongTitle();
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const orderByPopularity = () => {
    setOrderByPopularity();
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const handleSearchFilterChange = () => {
    toggleSearchFilters();
  };

  const renderSearchFilters = () => {
    if (environment) {
      return <SearchFilters
        id="catalog-filters"
        expanded={isSearchFiltersOn}
        onChange={handleSearchFilterChange}
        isOrderBySongTitleSet={isOrderBySongTitleSet}
        isOrderByArtistNameSet={isOrderByArtistNameSet}
        isOrderByPopularitySet={isOrderByPopularitySet}
        orderBySongTitle={orderBySongTitle}
        orderByArtistName={orderByArtistName}
        orderByPopularity={orderByPopularity}
        isAllLanguageFiltersSet={isAllLanguageFiltersSet}
        isAllGenreFiltersSet={isAllGenreFiltersSet}
        isAllDecadeFiltersSet={isAllDecadeFiltersSet}
        isAllAlphabetFiltersSet={isAllAlphabetFiltersSet}
        languages={environment.track_languages}
        filterLanguages={filterLanguages}
        genres={environment.genres}
        filterGenres={filterGenres}
        decades={decades}
        alphabets={alphabets}
        filterDecades={filterDecades}
        filterAlphabets={filterAlphabets}
        onAllLanguagesChange={handleAllLanguagesChange}
        onAllGenresChange={handleAllGenresChange}
        onAllDecadesChange={handleAllDecadesChange}
        onAllAlphabetsChange={handleAllAlphabetsChange}
        onLanguageChange={handleLanguageChange}
        onGenreChange={handleGenreChange}
        onDecadeChange={handleDecadeChange}
        onAlphabetChange={handleAlphabetChange}
      />;
    }
  };

  const renderExpandLessButton = () => {
    if (isSearchFiltersOn) {
      return <IconButton onClick={() => {
        handleSearchFilterChange();
        window.dispatchEvent(new Event('resize'));
      }}>
        <ExpandLess />
      </IconButton>;
    }
  };

  const refreshUI = () => {
    window.dispatchEvent(new Event('resize'));
  };

  const handleScroll = (scrollTop, scrollHeight) => {
    if (tracks) {
      console.log("scroller", scrollTop, scrollHeight);
      if (Math.abs(scrollTop - scrollHeight) <= 2) {
        getTracksMore(sessionToken, itemsOnPage);
        refreshUI();
        const element = document.getElementById('catalog-tracklist');
        if (element) {
          element.scrollTop = element.scrollHeight - element.clientHeight;
        }
      }
    }
  };

  const renderTotalCount = () => {
    if (tracks) {
      return <p className="muvika-catalog-total-text">{TR.cm_total}: {totalCount}</p>;
    }
  };

  const waitingRender = () => {
    if (isWaiting) {
      return <Waiting />;
    }
  };

  return (
    <div>
      <h3>{TR.cm_browse}</h3>
      <ContentContainer id="muvika-catalog" onScroll={handleScroll} isFinished={true} isSongbook={props.isSongbook}>
        {renderSearchFilters()}
        <Grid container spacing={0}>
          <Grid item xs={11}>
            {renderTotalCount()}
          </Grid>
          <Grid item xs={1}>
            {renderExpandLessButton()}
          </Grid>
        </Grid>
        {/* <TrackListScroller isCatalog={true} isSongbook={props.isSongbook} isWaiting={isWaiting} id="catalog-tracklist" tracks={tracks} onScrollDown={handleScrollDown} isFinished={isFinished} /> */}
        <List className="muvika-track-list-scroller-list">
          <TrackListContainer isOnFavoritesView={props.isOnFavoritesView} isBackgroundMusic={props.isBackgroundMusic} isSongbook={props.isSongbook} isNewTracks={props.isNewTracks} tracks={tracks} />
          {waitingRender()}
        </List>
      </ContentContainer>
    </div>
  );
}

export default Catalog;